import React from "react";

const ShopDetailSkeleton = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 py-10 grid grid-cols-1 lg:grid-cols-2 gap-10 animate-pulse">

      {/* LEFT IMAGE SECTION */}
      <div>
        {/* Main Image */}
        <div className="w-full h-[350px] bg-gray-300 rounded-xl"></div>

        {/* Gallery */}
        <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-7 gap-3 mt-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="w-full aspect-square bg-gray-300 rounded-md"></div>
          ))}
        </div>
      </div>

      {/* RIGHT SECTION */}
      <div className="space-y-6">

        {/* Title */}
        <div className="h-8 bg-gray-300 rounded w-3/4"></div>

        {/* Description */}
        <div className="space-y-2">
          <div className="h-4 bg-gray-300 rounded w-full"></div>
          <div className="h-4 bg-gray-300 rounded w-5/6"></div>
          <div className="h-4 bg-gray-300 rounded w-4/6"></div>
        </div>

        {/* Filter skeleton */}
        <div>
          <div className="h-5 bg-gray-300 rounded w-40 mb-4"></div>
          <div className="flex gap-4 flex-wrap">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="w-20 h-24 bg-gray-300 rounded-lg"></div>
            ))}
          </div>
        </div>

        {/* Input fields */}
        <div className="space-y-3">
          <div className="h-4 bg-gray-300 rounded w-40"></div>
          <div className="h-10 bg-gray-300 rounded w-full"></div>

          <div className="h-4 bg-gray-300 rounded w-40"></div>
          <div className="h-24 bg-gray-300 rounded w-full"></div>
        </div>

        {/* Upload box */}
        <div className="h-40 bg-gray-300 rounded-xl"></div>

        {/* Width / Height */}
        <div className="grid grid-cols-2 gap-6">
          <div className="h-16 bg-gray-300 rounded"></div>
          <div className="h-16 bg-gray-300 rounded"></div>
        </div>

        {/* Table */}
        <div className="h-32 bg-gray-300 rounded"></div>

        {/* Quantity + Price */}
        <div className="h-20 bg-gray-300 rounded-lg"></div>

        {/* Buttons */}
        <div className="flex gap-4">
          <div className="flex-1 h-12 bg-gray-300 rounded"></div>
          <div className="flex-1 h-12 bg-gray-300 rounded"></div>
        </div>

      </div>
    </div>
  );
};

export default ShopDetailSkeleton;